import { Link } from "react-router-dom";

export function LegalPage({ kind }: { kind: "privacy" | "terms" }) {
  const privacy = kind === "privacy";
  return (
    <main className="legal-page" id="main-content">
      <Link className="text-link" to="/">
        ← 返回 RoleWorth
      </Link>
      <p className="eyebrow">RoleWorth</p>
      <h1>{privacy ? "隐私说明" : "使用条款"}</h1>
      {privacy ? (
        <>
          <p>
            RoleWorth
            保存你主动提交的职位、评估、评分、标签和评论。服务默认不接收简历原文、本地个人文件或完整个人画像。
          </p>
          <p>
            每个用户拥有隔离的个人工作区。API Key 只保存不可还原的哈希，完整
            JD、评论正文和评估理由不会写入应用日志。
          </p>
          <p>你可以在设置页撤销 Agent 凭据，并随时导出自己的数据。</p>
        </>
      ) : (
        <>
          <p>RoleWorth 是私人职业机会资料库，不代替用户投递职位、发送消息或做最终职业决定。</p>
          <p>用户应确保提交的数据来源合法，并妥善保管会话和 Agent API Key。Agent 评估仅供参考。</p>
          <p>来源页面失效不会自动改变职位状态，已经保存的 JD 快照仍作为历史资料保留。</p>
        </>
      )}
    </main>
  );
}
